<template>
  <div class="g-wp w1200">
    <CommentModule ref="CommentModule"></CommentModule>
  </div>
</template>

<script>
import CommentModule from '../../components/commentModule.vue'

export default {
  name: 'commentDetail',
  components: {
    CommentModule
  },
  data() {
    return {}
  },
  mounted() {
    const { courseId, commentId } = this.$route.query
    this.$refs.CommentModule.init({
      courseId,
      commentId
    })
  },
  methods: {}
}
</script>

<style scoped lang="scss">
</style>